import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';

import MfpartySelection from './MfpartySelection';
export default function SelectPartyActionImpl(){

    return (
        <MfpartySelection/>
    )
}